module.exports = __webpack_public_path__ + "img/389-f6db4c.png";